import { render, staticRenderFns } from "./Template-05.vue?vue&type=template&id=2977e8e7&scoped=true&"
import script from "./Template-05.vue?vue&type=script&lang=js&"
export * from "./Template-05.vue?vue&type=script&lang=js&"
import style0 from "./Template-05.vue?vue&type=style&index=0&id=2977e8e7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2977e8e7",
  null
  
)

export default component.exports